import { Route } from 'react-router-dom';
import React from 'react';

export default function LayRoutes({
  element: Element, path, children, key,
}) {
  return (
    <Route key={key} path={path} element={<Element />}>
      {children?.map(LayRoutes)}
    </Route>
  );
}
